import { DEFAULT_LOCATIONS, BNSF, DROPDOWN } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 8154722fbd4aa7371bf1acdc9830b0cbe02173b4',
  staging: 'Token 7f6c7cf4386c3749f26be078870317681144233a',
  prod: 'Token b2cb3a9e10e7294e432b62d31103afdc71a3b298',
};

const token = selectToken(apiTokens);

const bnsfConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'bnsf',

  API_TOKEN: token,
  EMBOLD_CLIENT: BNSF,

  // login
  SHOW_REGION_SELECTOR: true,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.FortWorth },
  DEFAULT_SEARCH_RADIUS: 50,
  LOGIN_NETWORK_NAME: 'bnsfUserId',

  // content
  DISPLAY_NAME: 'BNSF',
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: false,
};

export default bnsfConfig;
